module.exports = __webpack_public_path__ + "img/screen_all.0df9aec6.png";